import BaseApi from './base.api'

class RegistryApi extends BaseApi {
  branchesUrl = 'branches/'
  buyerTypesUrl = 'buyer-types/'
  channelsUrl = 'channels/'
  channelTypesUrl = 'channel-types/'
  companyUrl = 'company-data/'
  customerContactsUrl = 'customer-contacts/'
  customerElectronicInvoiceAgreementTypesUrl = 'customer-electronic-invoice-agreement-types/'
  customerElectronicInvoiceUrl = 'customer-electronic-invoice/'
  customerPrivacyModuleFieldsUrl = 'customer-privacy-module-fields/'
  customerPrivacyModulesUrl = 'customer-privacy-modules/'
  customersSearchUrl = 'customers/search/'
  customersUrl = 'customers/'
  customerTypesUrl = 'customer-types/'
  depositsUrl = 'deposits/'
  discountCategoriesUrl = 'discount-categories/'
  discountCategoryAccountingsUrl = 'discount-category-accountings/'
  discountListsUrl = 'discount-lists/'
  documentSeriesUrl = 'document-series/'
  documentSeriesRulesUrl = 'document-series-rules/'
  externalPrivacyDataProcessorsUrl = 'external-privacy-data-processors/'
  identityDocumentAuthoritiesUrl = 'identity-authorities/'
  identityDocumentTypesUrl = 'identity-document-types/'
  importExportJobsUrl = 'import-export-jobs/'
  importExportJobRunsUrl = 'import-export-job-runs/'
  importExportJobRunRowsUrl = 'import-export-job-run-rows/'
  importableFieldsUrl = 'import-export/importable-fields/'
  importUniqueValuesUrl = 'import-export/unique-values/'
  importExportWizardCreateUrl = 'import-export/wizard-create/'
  previewImportFileUrl = 'import-export/preview/'
  infoBikeUrl = 'infobike/'
  jobTypesUrl = 'job-types/'
  packagingTypesUrl = 'packaging-types/'
  productFamiliesUrl = 'product-families/'
  productsSearchUrl = 'products/search/'
  productSupersessionUrl = (productId) => `${this.productsUrl}${productId}/supersessions/`
  productsUrl = 'products/'
  productAccountingsUrl = 'product-accountings/'
  productDocumentsUrl = 'product-documents/'
  productWeightsUrl = 'product-weights/'
  productStocksUrl = 'product-stocks/'
  serviceAttachmentsUrl = 'service-attachments/'
  subjectContactsUrl = 'subject-contacts/'
  subjectContactsSearchUrl = 'subject-contacts/search/'
  subjectDiscountsUrl = 'subject-discounts/'
  subjectDocumentsUrl = 'subject-documents/'
  subjectProfilesUrl = 'subject-profiles/'
  subjectsUrl = 'subjects/'
  subjectTypesUrl = 'subject-types/'
  supplierBrandsUrl = 'supplier-brands/'
  supplierBrandTransmissionsUrl = 'supplier-brand-transmissions/'
  supplierContactsUrl = 'supplier-contacts/'
  supplierDivisionsUrl = 'supplier-divisions/'
  supplierDivisionTypesUrl = 'supplier-division-types/'
  supplierOrderTypesUrl = 'supplier-order-types/'
  suppliersUrl = 'suppliers/'
  supplierTypesUrl = 'supplier-types/'
  vehiclesUrl = 'vehicles/'
  vehiclesInstantWebUrl = 'vehicles/instantWeb-trade-in-link'
  vehiclesSearchUrl = 'vehicles/search/'
  vehicleInterventionsUrl = 'vehicle-interventions/'
  vehicleMovementsUrl = 'vehicle-movements/'
  vehiclePlatesUrl = 'vehicle-plates/'
  vehicleTypesUrl = 'vehicle-types/'
  warehouseDocumentsUrl = 'warehouse-documents/'
  warehouseDocumentRowsUrl = 'warehouse-document-rows/'

  constructor() {
    super('registry/')
  }

  batchDeleteWarehouseDocumentsAsync = (ids) => this.post(`${this.warehouseDocumentsUrl}batch-delete/`, { ids })
  batchDeleteWarehouseDocumentRowsAsync = (ids) => this.post(`${this.warehouseDocumentRowsUrl}batch-delete/`, { ids })
  previewWarehouseDocumentRowConfirmationAsync = (id, quantity) => this.get(`${this.warehouseDocumentRowsUrl}${id}/confirm/`, quantity == null ? {} : { quantity })
  confirmWarehouseDocumentRowAsync = (id, token) => this.post(`${this.warehouseDocumentRowsUrl}${id}/confirm/`, { token })
  reorderWarehouseDocumentRowsAsync = (documentId, data) => this.post(`${this.warehouseDocumentRowsUrl}${documentId}/reorder_row_numbers/`, data)
  getImportableFieldsAsync = (params) => this.get(this.importableFieldsUrl, params)

  previewImportFileAsync = ({ uploadedFile, fileConfig }) => {
    const formData = new FormData()
    formData.append('file', uploadedFile)
    Object.entries(fileConfig).forEach(([key, value]) => {
      if (value !== null && value !== undefined) formData.append(key, value)
    })
    return this.post(this.previewImportFileUrl, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  }

  getImportUniqueValuesAsync = ({ uploadedFile, fileConfig, csvColumns, ownerMappings }) => {
    const formData = new FormData()
    formData.append('file', uploadedFile)
    if (ownerMappings) formData.append('owner_mappings', JSON.stringify(ownerMappings))
    else formData.append('csv_columns', JSON.stringify(csvColumns))
    Object.entries(fileConfig).forEach(([key, value]) => {
      if (value !== null && value !== undefined) formData.append(key, value)
    })
    return this.post(this.importUniqueValuesUrl, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  }

  createImportExportJobWizardAsync = ({ profile, fieldMappings, valueTranscodings, job, sourceFile }) => {
    const formData = new FormData()
    formData.append('profile', JSON.stringify(profile))
    formData.append('field_mappings', JSON.stringify(fieldMappings))
    formData.append('value_transcodings', JSON.stringify(valueTranscodings))
    formData.append('job', JSON.stringify(job))
    formData.append('source_file', sourceFile)
    return this.post(this.importExportWizardCreateUrl, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  }

  runImportExportJobAsync = (id, isDryRun = false, onlyErrors = false) => this.post(`${this.importExportJobsUrl}${id}/run/`, { isDryRun, onlyErrors })
  controlImportExportJobAsync = (id, action) => this.post(`${this.importExportJobsUrl}${id}/${action}/`)
  correctImportRowAsync = (id, values) => this.patch(`${this.importExportJobRunRowsUrl}${id}/correct/`, { values })

  getCompanyDataAsync = (params) => this.get(this.companyUrl, params)
  getCompanyAddressAsync = (address, params) => this.get(`address/${address}/`, params)
  updateCompanyDataAsync = (data) => this.patch(`${this.companyUrl}${data.id}/`, data)
  updateCompanyLogoAsync = (id, file) => {
    const formData = new FormData()
    formData.append('logo_file', file)
    return this.patch(`${this.companyUrl}${id}/`, formData)
  }

  getCustomersAsync = (params) => this.get(this.customersUrl, params)
  getCustomerPrivacyModuleFieldsAsync = (params) => this.get(this.customerPrivacyModuleFieldsUrl, params)
  isCustomerLockedAsync = (customerId) => this.get(`${this.customersUrl}${customerId}/locked-by`)
  downloadCustomerVatFileAsync = (vatFileId, fileName) => this.download(`${this.customersUrl}vat-files/${vatFileId}`, fileName)
  createSubjectAsync = (data) => this.post(this.subjectsUrl, data)
  createSubjectContactAsync = (data) => this.post(this.subjectContactsUrl, data)

  getBranchesAsync = (params) => this.get(this.branchesUrl, params)
  getBuyerTypesAsync = (params) => this.get(this.buyerTypesUrl, params)
  getChannelsAsync = (params) => this.get(this.channelsUrl, params)
  getChannelTypesAsync = (params) => this.get(this.channelTypesUrl, params)
  getCustomerElectronicInvoiceAgreementTypesAsync = (params) => this.get(this.customerElectronicInvoiceAgreementTypesUrl, params)
  getCustomerTypesAsync = (params) => this.get(this.customerTypesUrl, params)
  getDepositsAsync = (params) => this.get(this.depositsUrl, params)
  getDiscountCategoriesAsync = (params) => this.get(this.discountCategoriesUrl, params)
  createDiscountCategoryAsync = (data) => this.post(this.discountCategoriesUrl, data)
  getDiscountCategoryAccountingsAsync = (params) => this.get(this.discountCategoryAccountingsUrl, params)
  getDiscountListsAsync = (params) => this.get(this.discountListsUrl, params)
  getDocumentSeriesAsync = (params) => this.get(this.documentSeriesUrl, params)
  getDocumentSeriesRulesAsync = (params) => this.get(this.documentSeriesRulesUrl, params)
  getExternalPrivacyDataProcessorsAsync = (params) => this.get(this.externalPrivacyDataProcessorsUrl, params)
  getIdentityDocumentAuthoritiesAsync = (params) => this.get(this.identityDocumentAuthoritiesUrl, params)
  getIdentityDocumentTypesAsync = (params) => this.get(this.identityDocumentTypesUrl, params)
  getJobTypesAsync = (params) => this.get(this.jobTypesUrl, params)
  getPackagingTypesAsync = (params) => this.get(this.packagingTypesUrl, params)
  getProductAccountingsAsync = (params) => this.get(this.productAccountingsUrl, params)
  getProductByIdAsync = (id, params) => this.get(this.productsUrl, { id: id, ...params })
  getProductAsync = (params) => this.get(this.productsUrl, params)
  getProductDetailsAsync = (id, params) => this.get(`${this.productsUrl}${id}/details`, params)
  getProductFamiliesAsync = (params) => this.get(this.productFamiliesUrl, params)
  getProductStocksAsync = (params) => this.get(this.productStocksUrl, params)
  updateProductStockAsync = (id, data) => this.patch(`${this.productStocksUrl}${id}/`, data)
  getSubjectContactNextIdAsync = () => this.get(`${this.subjectContactsUrl}next/`)
  getSubjectDetailsAsync = (id, params) => this.get(`${this.subjectsUrl}${id}/details`, params)
  getSubjectNextIdAsync = () => this.get(`${this.subjectsUrl}next/`)
  getWarehouseDocumentNextIdByDataAsync = (data) => this.post(`${this.warehouseDocumentsUrl}next/`, data)
  getWarehouseDocumentByIdAsync = (id) => this.get(`${this.warehouseDocumentsUrl}${id}/`)
  getSubjectTypesAsync = (params) => this.get(this.subjectTypesUrl, params)
  getSupplierDivisionsAsync = (params) => this.get(this.supplierDivisionsUrl, params)
  getSupplierDivisionTypesAsync = (params) => this.get(this.supplierDivisionTypesUrl, params)
  getSupplierOrderTypesAsync = (params) => this.get(this.supplierOrderTypesUrl, params)
  getSuppliersAsync = (params) => this.get(this.suppliersUrl, params)
  getSupplierTypesAsync = (params) => this.get(this.supplierTypesUrl, params)
  getSupplierDivisionNextIdAsync = () => this.get(`${this.supplierDivisionsUrl}next/`)

  deleteProductByIdAsync = (id, config) => this.delete(`${this.productsUrl}${id}`, config)
  createProductAsync = (data) => this.post(this.productsUrl, data)
  updateProductAsync = (id, data) => this.patch(`${this.productsUrl}${id}`, data)

  getSupplierBrandsAsync = (params) => this.get(this.supplierBrandsUrl, params)
  createSupplierBrandAsync = (data) => this.post(this.supplierBrandsUrl, data)
  mergeSupplierBrandsAsync = (data) => this.post(`${this.supplierBrandsUrl}merge-supplier-brands/`, data)
  getSubjectContactsAsync = (params) => this.get(this.subjectContactsUrl, params)
  getSubjectDiscountsAsync = (params) => this.get(this.subjectDiscountsUrl, params)
  createSubjectDiscountAsync = (data) => this.post(this.subjectDiscountsUrl, data)

  getVehiclesAsync = (vehicleId, params) => this.get(`${this.vehiclesUrl}${vehicleId || ''}`, params)
  getInfoBikeBrandsAsync = (params) => this.get(`${this.infoBikeUrl}brands/`, params)
  getInfoBikeModelsAsync = (params) => this.get(`${this.infoBikeUrl}models/`, params)
  getInfoBikeVariantsAsync = (params) => this.get(`${this.infoBikeUrl}variants/`, params)
  getInfoBikeDataByInfoBikeCodeAsync = (params) => this.get(`${this.infoBikeUrl}data-by-infoBikeCode/`, params)
  getVehicleMovementsNextIdAsync = () => this.get(this.vehicleMovementsUrl)
  getVehicleNextIdAsync = (params) => this.get(`${this.vehiclesUrl}next/`, params)
  getVehiclePlatesAsync = (params) => this.get(this.vehiclePlatesUrl, params)
  getVehicleTypesAsync = (params) => this.get(this.vehicleTypesUrl, params)
  createVehicleAsync = (data) => this.post(this.vehiclesUrl, data)
  createVehicleMovementAsync = (data) => this.post(this.vehicleMovementsUrl, data)

  createDocumentSeriesRuleAsync = (data) => this.post(this.documentSeriesRulesUrl, data)

  updateCustomerPrivacyModuleAsync = (id, data) => this.patch(`${this.customerPrivacyModulesUrl}${id}/`, data)
  updateSubjectAsync = (id, data) => this.patch(`${this.subjectsUrl}${id}/`, data)

  getVehicleNextCarServiceAsync = (vehicleId) => this.get(`${this.vehiclesUrl}next-filtered/`, { vehicle: vehicleId })
  getInfoBikeSearchAsync = (plate_number) => this.get(`${this.vehiclesUrl}infoBike-search/`, { plate: plate_number })

  printPrivacyAsync = (filename, data, config) => this.download(`${this.customersUrl}print/`, filename, null, false, { ...config, method: 'post', data: data })
  checkCustomerPrivacyAsync = (customerId) => this.post(`${this.customersUrl}check-customer-privacy/`, { customer_id: customerId })

  getAttachmentAsync = (params) => this.get(this.serviceAttachmentsUrl, params)
  getAttachmentChartDataAsync = (params) => this.get(`${this.serviceAttachmentsUrl}chart-data/`, params)
  batchDeleteServiceAttachmentsAsync = (ids) => this.post(`${this.serviceAttachmentsUrl}batch-delete/`, { ids })
  previewAttachmentByIdAsync = (id) => this.downloadBlob(`${this.serviceAttachmentsUrl}${id}/download/`, null, false, { method: 'post' })
  uploadServiceAttachmentAsync = (data, file, config = {}) => {
    const formData = new FormData()
    Object.entries(data).forEach(([key, value]) => { if (value != null) formData.append(key, value) })
    formData.append('attachment_file', file)
    return this.post(`${this.serviceAttachmentsUrl}upload-attachment/`, formData, config)
  }

  getInstantWebTradeInLinkAsync = (params) => this.get(this.vehiclesInstantWebUrl, params)

  getImportExportJobRunsAsync = (params) => this.get(this.importExportJobRunsUrl, params)
  getImportExportJobsAsync = (params) => this.get(this.importExportJobsUrl, params)
  batchDeleteImportExportJobsAsync = (ids) => this.post(`${this.importExportJobsUrl}batch-delete/`, { ids })
}

export const registryApi = new RegistryApi()
